/**
 * Shared HTML/URL safety helpers. Any string that came from the database
 * (POI names, categories, descriptions, media URLs) must go through these
 * before being interpolated into innerHTML or used as a navigation target —
 * writes are network-reachable, so treat stored content as untrusted.
 */

/** Escapes &<>"' for safe interpolation into innerHTML. */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
}

/**
 * True only for http:/https: URLs. Blocks javascript:, data:, blob:, etc. —
 * a `javascript:` URL assigned to an iframe src or anchor href executes in
 * this page's origin. Use before linkFrame.src / href / window.open.
 */
export function isSafeHttpUrl(url: string): boolean {
  try {
    const u = new URL(url, location.href);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}
